import React from "react"
import { FormattedMessage, } from "react-intl"
import AccountStatement from "../../../customer/account-statement/model/AccountStatement"

type OwnProps = {
    accountStatement: AccountStatement,
}

const AccountStatementCreatedComponent = (props: OwnProps) => {

    return <div className={"row"}>
        <div
            className="col-12"
            data-document-event="account-statement-created">
            <FormattedMessage
                id="quote.events.account_statement_created.text"
                defaultMessage="Account Statement {identifier} has been created"
                values={{
                    identifier: props.accountStatement.getIdentifier()
                }}
            />
        </div>
    </div>
}

export default AccountStatementCreatedComponent


// WEBPACK FOOTER //
// ./src/quote/analytics/events/account-statement-created.component.tsx